module.exports = __webpack_public_path__ + "static/media/plp_right_icon.ef9aa299.svg";